import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button, Modal, Image } from "react-bootstrap";
import { get } from "lodash";
import { getRolesAction } from "../../../actions/userManagement.action";
import {
  getSearchInputData,
  resetSearchInputData
} from "../../../actions/common.action";
import CreateRoleForm from "./createRoles.Form";
import { LoaderPage } from "../../../component/Loader";
import { STATUS } from "../../../constant";
import { isValidArray, searchByValueHelper } from "../../../helper";
import { PopUpModel } from "../../../component/PopUp";
import { PAGE_COUNT } from "../helper";
import DisplayByPermission from "../../../component/DisplayByPermission";
import PermissionHOC from "../../PermissionHOC";
import { toast } from "react-toastify";
import { Search, TableTemplate } from "../../reusableComponent";
import { headerOptions } from "../usermangement.constant";
import Pagination from "../../Pagination";
import RolesIcon from "../../../assets/roles.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import EditImage from "../../../assets/edit-image.svg";
import ViewOnlyIcon from "../../../assets/view-icon.svg";
import { successToastStyle, errorToastStyle } from "../../../customToast";
class CreateRolesListing extends Component {
  constructor(props) {
    super(props);
    this.roleModelRef = React.createRef();
    this.state = {
      offset: 0,
      minRange: 0,
      maxRange: PAGE_COUNT,
      sortedListingArr: []
    };
  }

  componentDidMount() {
    const { getRolesListDispatch } = this.props;
    getRolesListDispatch(undefined);
  }

  componentWillUnmount() {
    const { resetSearchInputData } = this.props;
    resetSearchInputData();
  }

  onToggleModal = value => {
    this.setState(prevState => ({
      displayModal: !prevState.displayModal
    }));
  };

  onEdit = value => {
    const isEdit = this.state.isEdit;
    this.setState({
      isEdit: !isEdit,
      groupData: (!isEdit && value) || null
    });
  };

  onDeleteAlertToggle = value => {
    const displayDeleteAlert = this.state.displayDeleteAlert;
    this.setState({
      displayDeleteAlert: !displayDeleteAlert,
      deleteData: (!displayDeleteAlert && value) || null
    });
  };

  onDelete = async value => {
    const { deleteGroupDispatch, getGroupsListDispatch } = this.props;
    const { deleteData } = this.state;
    const response = await deleteGroupDispatch(undefined, {
      groupID: get(deleteData, "id", -1)
    });
    if (response) {
      const { status, message } = response;
      (status &&
        toast.success(
          <p className="toast-text-alignment">{message}</p>,
          successToastStyle
        )) ||
        toast.error(
          <p className="toast-text-alignment">{message}</p>,
          errorToastStyle
        );
      status && getGroupsListDispatch(undefined);
    } else {
      toast.error(
        <p className="toast-text-alignment">Some issues happen</p>,
        errorToastStyle
      );
    }
  };

  onPageChange = pageInfo => {
    const { rolesListing } = this.props;
    isValidArray(get(rolesListing, "data")) &&
      this.setState(prevState => ({
        ...pageInfo,
        offset: pageInfo.selected || 0
      }));
  };

  getFilteredData = sortedListingArr => {
    this.setState({
      sortedListingArr: get(sortedListingArr, "sortData", []),
      isSearching: get(sortedListingArr, "isSearching")
    });
  };

  onSearch = (e, values) => {
    const { name, value } = values;
    this.setState({
      [name]: value
    });
  };

  render() {
    const {
      state: {
        isEdit,
        offset,
        search,
        minRange,
        maxRange,
        groupData,
        displayModal,
        displayDeleteAlert
      },
      props: { permission, rolesListing, isApiLoading },
      onSearch
    } = this;

    const sortedListingArr = searchByValueHelper(
      get(rolesListing, "data", []),
      search,
      ["name"]
    ).filter(value => value.display);

    const list = sortedListingArr.filter(
      (value, index) => index >= minRange && index < maxRange
    );

    return (
      <div className="group-management">
        <div className="header">
          <h3>
            Role{" "}
            {(get(rolesListing, "data") && (
              <span>({get(rolesListing, "data").length})</span>
            )) ||
              (!isValidArray(list) && <span>(0)</span>) ||
              null}
          </h3>
          <div className="header-buttons d-flex flex-row">
            <div className="issue-list-exposed-filters  pb-2 pr-4">
              <div className="issue-list-filter-right role-search">
                <Search
                  placeholder="Search"
                  keyName="search"
                  onChange={onSearch}
                  value={search}
                />
              </div>
            </div>
            <DisplayByPermission
              display={
                get(permission, "createRole") &&
                !get(permission, "canViewOnlyProject")
              }
            >
              <OverlayTrigger
                trigger="hover"
                defaultShow={false}
                placement="bottom"
                overlay={
                  <Tooltip
                    id={`tooltip-checking`}
                    className="create_project_tolltip"
                  >
                    Create Role
                  </Tooltip>
                }
              >
                <Button
                  className="btn-orange create-btn"
                  size="sm"
                  onClick={this.onToggleModal}
                >
                  <div>
                    <Image src={RolesIcon} className="create-role" />
                  </div>
                </Button>
              </OverlayTrigger>
            </DisplayByPermission>
          </div>
        </div>
        {/*  Edit Modal Start **/}
        <Modal
          size="lg"
          show={isEdit}
          onHide={this.onEdit}
          aria-labelledby="example-modal-sizes-title-lg"
          className="content-modal"
        >
          <div className="modal-box-shadow" ref={this.roleModelRef}>
            <Modal.Header
              closeButton
              className="header-modal role-header-modal"
            >
              <Modal.Title id="example-modal-sizes-title-lg">
                {!get(permission, "canViewOnlyProject")
                  ? "Edit Role"
                  : "View Role"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="body-modal">
              <CreateRoleForm
                togglePopUp={this.onEdit}
                isEdit={isEdit}
                groupData={groupData}
                permission={permission}
                roleModelRef={this.roleModelRef}
              />
            </Modal.Body>
          </div>
        </Modal>
        {/*  Edit Modal End **/}

        {/*  Create Modal **/}
        <Modal
          size="lg"
          show={displayModal}
          onHide={this.onToggleModal}
          aria-labelledby="example-modal-sizes-title-lg"
          className="content-modal  create-user-form"
        >
          <div ref={this.roleModelRef}>
            <Modal.Header
              closeButton
              className="header-modal role-header-modal"
            >
              <Modal.Title id="example-modal-sizes-title-lg">
                Create Role
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="body-modal create-user-body-modal">
              <CreateRoleForm
                togglePopUp={this.onToggleModal}
                roleModelRef={this.roleModelRef}
              />
            </Modal.Body>
          </div>
        </Modal>
        {/*  Create Modal End **/}

        {/*  Delete Alert Pop Up **/}

        <PopUpModel
          open={displayDeleteAlert}
          text={"Are you sure you want to delete it?"}
          leftBtnText={"Yes"}
          rightBtnText={"No"}
          onCancel={this.onDeleteAlertToggle}
          onSubmit={this.onDelete}
        />

        {isValidArray(get(rolesListing, "data")) ? (
          <React.Fragment>
            <TableTemplate
              isRoleTable={true}
              isUsersTable={true}
              isLoading={isApiLoading === STATUS.LOADING}
              headersOptions={headerOptions}
              bodyOptions={list}
              bodyTemplate={(options, index) => (
                <>
                  <td>{index + minRange + 1}</td>
                  <td>{options.name}</td>
                  <td>
                    {get(permission, "updateRole") ? (
                      <Image
                        className={"edit-image"}
                        src={
                          !get(permission, "canViewOnlyProject")
                            ? EditImage
                            : ViewOnlyIcon
                        }
                        onClick={this.onEdit.bind(this, options)}
                      />
                    ) : null}
                  </td>
                </>
              )}
              headersTemplate={options => (
                <>
                  <th>{options.title}</th>
                </>
              )}
            />
            {isApiLoading === STATUS.SUCCESS ? (
              <div className="pagination-wrapper">
                <div className="pagination pagination-in-user-listing">
                  <Pagination
                    offset={offset}
                    pageCount={sortedListingArr.length / PAGE_COUNT}
                    onPageChange={this.onPageChange}
                  />
                </div>
              </div>
            ) : null}
          </React.Fragment>
        ) : (
          <LoaderPage loading={isApiLoading !== STATUS.SUCCESS} />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    rolesListing: state.userManagementReducer.rolesList,
    isApiLoading: state.userManagementReducer.isApiLoading,
    searchInput: state.commonReducer.searchInput
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getRolesListDispatch: getRolesAction,
      getSearchInputData: getSearchInputData,
      resetSearchInputData: resetSearchInputData
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PermissionHOC(CreateRolesListing));
